import { debounce } from './utilities';

// MOBILE SEARCH OPEN/CLOSE
window.showSearch = function showSearch() {
    var searchForm = document.getElementsByClassName('search_form')[0];
    searchForm.classList.toggle('open');
    document.querySelector('.hamburger-menu').classList.toggle('hidden');
}


// SIDEBAR OPEN/CLOSE
window.toggleSidebar = function toggleSidebar(){
    var sidebar = document.getElementsByClassName('sidebar')[0];
    var main = document.getElementsByClassName('main')[0];
    var mask = document.getElementsByClassName('mask')[0];
    var catfish = document.getElementsByClassName('shortlist-catfish')[0];
    var sidebarOpen = false;
    if (sidebar.classList.contains('open')){
        sidebarOpen = false;
        sidebar.classList.remove('open');
        main.classList.remove('open');
        mask.classList.remove('show');
        catfish.classList.remove('hideCatfish');
    } else {
        sidebarOpen = true;
        sidebar.classList.add('open');
        main.classList.add('open');
        mask.classList.add('show');
        catfish.classList.add('hideCatfish')
    }
}


// NAVBAR SCROLL BEHAVIOUR
var lastScrollTop = 0, delta = 5;
const mainNavElement = document.querySelector('.main-nav');
export function navScrollHeaderHide() {
    // wf-seo-opt-2026 new code start
    // this uses native scroll offset and a cached nav element for lower handler cost
    var st = window.pageYOffset || document.documentElement.scrollTop;

    if(Math.abs(lastScrollTop - st) <= delta) {
        return;
    }

    if (st > lastScrollTop && st > 10){
        if (mainNavElement) {
            mainNavElement.classList.add('fixed-header');
        }
    } else {
        if (mainNavElement) {
            mainNavElement.classList.remove('fixed-header');
        }
    }
    lastScrollTop = st;
    // wf-seo-opt-2026 new code end

    /* wf-seo-opt-2026 old code start
    var st = $(this).scrollTop();
    if(Math.abs(lastScrollTop - st) <= delta) {
        return;
    }
    if (st > lastScrollTop && st > 10){
        $('.main-nav').addClass('fixed-header');
    } else {
        $('.main-nav').removeClass('fixed-header');
    }
    lastScrollTop = st;
    wf-seo-opt-2026 old code end */
} 
            
    



// SEARCH AUTOSUGGEST //
const searchBarElement = document.getElementsByClassName('searchbox')[0];
const searchInputElement = document.getElementById('search-keywords');
let searchResultsElement = document.querySelector('.search-results');
let currentSearchAbortController = null;

window.search = debounce(function(){
    // wf-seo-opt-2026 new code start
    // this caches static dom nodes and aborts stale network requests from previous key presses
    let searchBar = searchBarElement;
    let searchResults = searchResultsElement;
    if (!searchResults) {
        searchResults = document.querySelector('.search-results');
        searchResultsElement = searchResults;
    }
    if (!searchInputElement || !searchResults) {
        return;
    }
    let placeholderSearch = "<li><div><span class='placeholder-result'></span></div></li><li><div><span class='placeholder-result'></span></div></li><li><div><span class='placeholder-result'></span></div></li><li><div><span class='placeholder-result'></span></div></li><li><div><span class='placeholder-result'></span></div></li>";
    
    let keyword = searchInputElement.value;

    const channels = {
        6: "Business Advice",
        7: "Companies",
        12: "Success Stories",
        15: "Events",
        18: "Featured Post",
        11: "News",
        9: "Questions",
        14: "Videos"
    }

    if (keyword.length === 0 || keyword === ' ') {
        searchResults.innerHTML = "";
        return;
    }
    searchResults.innerHTML = placeholderSearch;

    // ADDED_2025_PERFORMANCE_REFACTOR - fixed to handle actual search.php response format
    if (currentSearchAbortController) {
        currentSearchAbortController.abort();
    }
    currentSearchAbortController = new AbortController();

    fetch('/assets/php/search.php?keyword=' + encodeURIComponent(keyword), {
        signal: currentSearchAbortController.signal
    })
    .then(response => response.json())
    .then(results => {
        // handle undefined or non-array response
        if (!results || !Array.isArray(results)) {
            searchResults.innerHTML = "<li> No results </li>";
            return;
        }

        // track interaction with search form
        dataLayer.push({
            'event': 'myTrackEvent',
            'eventCategory': 'Search',
            'eventAction': 'Search Request',
            'eventLabel': results.length
        });

        if (results.length === 0) {
            searchResults.innerHTML = "<li> No results </li>";
            return;
        }

        searchResults.innerHTML = '<li><h4>Top Results</h4></li>';
        results.forEach(result => {
            // handle both array and string formats for backwards compatibility
            let title = Array.isArray(result.title) ? result.title[0] : result.title;
            let url = Array.isArray(result.url) ? result.url[0] : result.url;
            
            let aTag = document.createElement('a');
            aTag.href = url;
            aTag.addEventListener('click', function() {
                dataLayer.push({
                    'event': 'myTrackEvent',
                    'eventCategory': 'Search',
                    'eventAction': 'Search Result Click',
                    'eventLabel': title
                });
            })

            let liTag = document.createElement('li');
            // use highlights if available, otherwise use title directly
            let matchedResult = (result.highlights && result.highlights.title) ? result.highlights.title : title;
            // show channel if available
            let channelDisplay = '';
            if (result.channel) {
                let channelId = Array.isArray(result.channel) ? result.channel[0] : result.channel;
                if (channels[channelId]) {
                    channelDisplay = ` - <span class='search-channel'>${channels[channelId]}</span>`;
                }
            }
            liTag.innerHTML = matchedResult + channelDisplay;

            aTag.appendChild(liTag);
            searchResults.appendChild(aTag);
        })

    })
    .catch(error => {
        if (error && error.name === 'AbortError') {
            return;
        }
        searchResults.innerHTML = "<li> Search unavailable </li>";
    })
    // wf-seo-opt-2026 new code end

    /* wf-seo-opt-2026 old code start
    var searchBar = document.getElementsByClassName('searchbox')[0];
    let searchResults = document.querySelector('.search-results');
    let keyword = document.getElementById('search-keywords').value;
    fetch('/assets/php/search.php?keyword=' + keyword)
    wf-seo-opt-2026 old code end */
    // END ADDED_2025_PERFORMANCE_REFACTOR

    if (document.getElementById("suggested-results").innerHTML != ""){
        searchBar.style.width = "100%";
    } else {
        searchBar.style.width = "";
    }
},300)